var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg20 = function Svg20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54 3.707a.65.65 0 0 1 .92 0l5.833 5.833a.65.65 0 0 1-.92.92L10.65 5.736v10.097a.65.65 0 1 1-1.3 0V5.736L4.626 10.46a.65.65 0 1 1-.919-.92L9.54 3.707Z",
    fill: "currentColor"
  })));
};

export { Svg20 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjU0MDQxIDMuNzA3MDVDOS43OTQyNSAzLjQ1MzIxIDEwLjIwNTggMy40NTMyMSAxMC40NTk2IDMuNzA3MDVMMTYuMjkzIDkuNTQwMzhDMTYuNTQ2OCA5Ljc5NDIyIDE2LjU0NjggMTAuMjA1OCAxNi4yOTMgMTAuNDU5NkMxNi4wMzkxIDEwLjcxMzUgMTUuNjI3NiAxMC43MTM1IDE1LjM3MzcgMTAuNDU5NkwxMC42NSA1LjczNTkxTDEwLjY1IDE1LjgzMzNDMTAuNjUgMTYuMTkyMyAxMC4zNTkgMTYuNDgzMyAxMCAxNi40ODMzQzkuNjQxMDQgMTYuNDgzMyA5LjM1MDAzIDE2LjE5MjMgOS4zNTAwMyAxNS44MzMzTDkuMzUwMDMgNS43MzU5MUw0LjYyNjMxIDEwLjQ1OTZDNC4zNzI0NyAxMC43MTM1IDMuOTYwOTEgMTAuNzEzNSAzLjcwNzA3IDEwLjQ1OTZDMy40NTMyMyAxMC4yMDU4IDMuNDUzMjMgOS43OTQyMiAzLjcwNzA3IDkuNTQwMzhMOS41NDA0MSAzLjcwNzA1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";